/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TimeLineGroupInfoRequest = {
  groupId: number;
  page?: number;
  perPage?: number;
  keyword?: string | null;
  sort?: string | null;
  direction?: TimeLineGroupInfoRequest.direction | null;
};

export namespace TimeLineGroupInfoRequest {
  export enum direction {
    ASC = "asc",
    DESC = "desc",
  }
}
